import React, {
  DetailedHTMLProps, HTMLAttributes, FC,
} from 'react';
import styled from 'styled-components';
import { isTwilioConnected } from 'models/twilio';
import { useSelector } from 'react-redux';

const ConnectedWrapper = styled.div<{ $isConnected: boolean, $pointerEvents: boolean, $disabledOpacity: number }>`
  ${({ $disabledOpacity, $isConnected, $pointerEvents }) => !$isConnected && `
    opacity: ${$disabledOpacity};
    pointer-events: ${$pointerEvents ? 'all' : 'none'};
  `}
  transition: opacity 0.3s ease;
`;

export type TwilioConnectedWrapperProps = Omit<
  DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>,
  'ref'> & { disabledOpacity?: number; enablePointerEvents?: boolean; };

const TwilioConnectedWrapper: FC<TwilioConnectedWrapperProps> = ({
  enablePointerEvents = false,
  disabledOpacity = 0.7,
  children,
  ...divProps
}) => {
  const twilioConnected = useSelector(isTwilioConnected);

  return (
    <ConnectedWrapper
      $isConnected={twilioConnected}
      $pointerEvents={enablePointerEvents}
      $disabledOpacity={disabledOpacity}
      {...divProps}
    >
      {children}
    </ConnectedWrapper>
  );
};

export default TwilioConnectedWrapper;
